
import { defineComponent, ref } from 'vue';
import { useList } from '@/hooks/use-list';
import CustomTable from '@/components/custom-table';
import { renderColumns } from './composables/tableData';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getZoneParseList, updateZoneStatus } from '@/api/domain-system';
import {
  ISDEL_STATUS_ENUM,
  IZoneParseListReq,
  IZoneParseListRes,
  IZoneParseListResListItem,
  ZONE_STATUS_ENUM,
} from '@/api/domain-system/type';

export default defineComponent({
  name: 'DomainSystemList',
  components: {
    CustomTable,
  },
  setup() {
    // 批量选中的行
    const selectedRows = ref<IZoneParseListResListItem[]>([]);
    // 获取列表数据
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IZoneParseListRes, IZoneParseListReq>({
      request: {
        api: getZoneParseList,
        params: {
          zone: '',
          rr: '',
          pageNum: 1,
          pageSize: 20,
        },
      },
    });
    handleSearch();
    // 删除
    const submitDel = (rows: IZoneParseListResListItem[]) => {
      ElMessageBox.prompt(
        '确定删除选中的数据吗？',
        '温馨提醒',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          inputPlaceholder: '请输入备注',
          inputType: 'textarea',
          inputErrorMessage: '备注不能为空',
          inputValidator: (value: any) => {
            if (value) {
              return true;
            }
            return false;
          },
        },
      )
        .then(async ({ value }) => {
          const parseIds: string[] = rows.map(n => n.parseId);
          try {
            await updateZoneStatus({
              parseIds,
              isDeleted: ISDEL_STATUS_ENUM.YES,
              remark: value,
            });
            ElMessage({
              type: 'success',
              message: '删除成功！',
            });
            handleSearch();
          } catch (error) {
            console.error(error);
          }
        })
        .catch(() => {
          // 取消删除
        });
    };

    // 批量删除按钮
    const delBatch = () => {
      submitDel(selectedRows.value);
    };
    // 表格中的多选
    const handleSelectionChange = (rows: IZoneParseListResListItem[]) => {
      selectedRows.value = rows || [];
    };
    // 表格中的更新启用与否
    const handleUpdateStatus = async (row:IZoneParseListResListItem) => {
      try {
        await updateZoneStatus({
          parseIds: [row.parseId],
          enableState: row.dnsState === ZONE_STATUS_ENUM.ENABLE ? ZONE_STATUS_ENUM.DISABLE : ZONE_STATUS_ENUM.ENABLE,
        });
        ElMessage.success('操作成功');
        handleSearch();
      } catch (error) {
        console.error('更新状态失败', error);
      }
    };

    return {
      submitDel,
      renderColumns,
      handleUpdateStatus,
      selectedRows,
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      delBatch,
      handleSelectionChange,
    };
  },
});

